import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { format, addDays } from "date-fns";
import SelectDropdown from "../components-react/SelectDropdown";
import DateRanger from "../components-react/DateRanger";
import { Button } from "react-bootstrap";
import { selectGymData } from "../../redux/reducers/gymDataSlice";
import moment from "moment";
import { fetchGymData } from "../../data/APIs";
import { payment_location } from "../common-data/DropdowData";
import {
  BiCheckIcon,
  BiXIcon,
  CalenderIcon,
  RedCrossIcon,
  ReloadIcon,
} from "../../images/icons/icons";

const PTTrialFilters = ({
  filters,
  setFilters,
  setSendableStatsFilters,
  setSendableFilters,
  setPTDatas,
  onClickReset,
  decryptedText,
  trainerReceptionistInfo,
  isLoading,
  ptDatas,
  handleToggle,
  toggle,
  isReload,
}) => {
  const dispatch = useDispatch();
  const gymData = useSelector(selectGymData);

  const isAdmin = decryptedText?.account_type === "admin";
  const isTrainer = decryptedText?.account_type === "trainer";
  const isReceptionist = decryptedText?.account_type === "receptionist";
  const isFitnessManager = decryptedText?.account_type === "fitness_manager";
  // Multi-gym managers can have multiple authorized gyms — show them the
  // gym filter dropdown so they can switch between their assigned gyms.
  // Backend enforces that only their authorized gyms are accessible.
  const isMultiGymManager = [
    "sales_manager",
    "fitness_manager",
    "club_manager",
    "cluster_manager",
  ].includes(decryptedText?.account_type);

  const [openDateRanger, setOpenDateRanger] = useState(false);
  const initialRangeState = [
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: "selection",
    },
  ];
  const [rangeState, setRangeState] = useState(initialRangeState);

  const handleDateRangeChange = (item) => {
    setRangeState([item?.selection]);

    const formattedStartDate = format(item?.selection?.startDate, "yyyy-MM-dd");
    const formattedEndDate = format(item?.selection?.endDate, "yyyy-MM-dd");

    setFilters({
      ...filters,
      selSubscriptionAddDateFrom: formattedStartDate,
      selSubscriptionAddDateTo: formattedEndDate,
    });
  };

  const clearDateRanger = () => {
    setOpenDateRanger(false);
    setRangeState(initialRangeState);
    setFilters({
      ...filters,
      selSubscriptionAddDateFrom: "",
      selSubscriptionAddDateTo: "",
    });
  };

  useEffect(() => {
    setSendableFilters((prevs) => ({
      ...prevs,
      gym_id:
        (isReceptionist || isTrainer) && trainerReceptionistInfo?.gym_id
          ? trainerReceptionistInfo.gym_id
          : filters.selectedGym?.value
          ? filters.selectedGym.value
          : "",
      start_date: filters.selSubscriptionAddDateFrom || "",
      end_date: filters.selSubscriptionAddDateTo || "",
    }));

    setPTDatas((prevs) => ({ ...prevs, isPage: 0 }));
  }, [
    filters.selectedGym,
    filters.selSubscriptionAddDateFrom,
    filters.selSubscriptionAddDateTo,
    trainerReceptionistInfo,
  ]);

  useEffect(() => {
    setSendableStatsFilters((prevs) => ({
      ...prevs,
      gym_id:
        (isReceptionist || isTrainer) && trainerReceptionistInfo?.gym_id
          ? trainerReceptionistInfo.gym_id
          : filters.selectedGym?.value
          ? filters.selectedGym.value
          : "",
      assigned_to:
        isTrainer && trainerReceptionistInfo?.user_id
          ? trainerReceptionistInfo.user_id
          : filters.selectedTrainer?.value
          ? filters.selectedTrainer.value
          : "",
      handover_status: isTrainer
        ? "handover_completed"
        : filters.selectedHandoverStatus?.value
        ? filters.selectedHandoverStatus.value
        : "",
      start_date: filters.selSubscriptionAddDateFrom || "",
      end_date: filters.selSubscriptionAddDateTo || "",
    }));
  }, [
    filters.selectedGym,
    filters.selSubscriptionAddDateFrom,
    filters.selSubscriptionAddDateTo,
    filters.selectedHandoverStatus,
    filters.selectedTrainer,
    trainerReceptionistInfo,
  ]);

  useEffect(() => {
    // Fetch gym list for everyone who CAN switch gyms in the UI.
    // Backend gym-list endpoint already restricts the returned set to the
    // user's authorized gyms (cluster_manager_gyms / gym_manager_master).
    if (isAdmin || isMultiGymManager) {
      dispatch(fetchGymData(decryptedText?.token));
    }
  }, []);

  return (
    <>
      <div
        className={`cmnFilterStructureContainer ptTrackContainer`}
        style={{ marginTop: "1rem" }}
      >
        <div className="filterblock gridSpanTwo">
          {openDateRanger && (
            <DateRanger
              handleDateRangeChange={handleDateRangeChange}
              rangeState={rangeState}
              onClose={() => setOpenDateRanger(false)}
              onClear={clearDateRanger}
            />
          )}

          <div className="filterHeadingNBtn">
            <h5 className="filterHeading">
              All Filters{" "}
              {isReload ? (
                <button
                  variant="dark"
                  type="button"
                  onClick={isReload}
                  style={{
                    width: "24px",
                    height: "24px",
                    borderRadius: "50%",
                    border: "none",
                    backgroundColor: "#000",
                    cursor: "pointer",
                    color: "#fff",
                    marginLeft: "10px",
                  }}
                >
                  <ReloadIcon />
                </button>
              ) : null}
            </h5>
            <div>
              <div
                style={{
                  display: "inline-block",
                  marginRight: "1rem",
                  verticalAlign: "middle",
                  marginLeft: "1rem",
                }}
              >
                <label className="docs-toggle-switch">
                  <input
                    type="checkbox"
                    className="docs-toggle-switch__input"
                    checked={toggle}
                    onChange={handleToggle}
                  />
                  <span className="docs-toggle-switch__slider" />
                  Show Future Trial
                </label>
              </div>

              {!isLoading && (
                <Button variant="outline-danger" onClick={onClickReset}>
                  Reset Filter
                </Button>
              )}
            </div>
          </div>

          <div className="filtersDropdown grid3">
            {(isAdmin || isMultiGymManager) && (
              <div
                className={`commonWrapper dropdownCommonWrapper ${
                  filters?.selectedGym?.value && "redBorderRedText"
                }`}
              >
                <SelectDropdown
                  options={gymData}
                  selectedOption={filters?.selectedGym}
                  setSelectedOption={(selectedValue) =>
                    setFilters({
                      ...filters,
                      selectedGym: selectedValue,
                    })
                  }
                  name="Gym"
                  isDisable={isLoading}
                />
              </div>
            )}

            <div
              className={`commonWrapper dropdownCommonWrapper darerangerCommonWrapper ${
                filters?.selSubscriptionAddDateFrom ||
                filters?.selSubscriptionAddDateTo
                  ? "redBorderRedText"
                  : ""
              }`}
            >
              {openDateRanger ? (
                <div className="closeAndClearDateRangerButtons">
                  <button
                    className="closeClearBtn notmalButtonStyles noStyle closeRangerBtn"
                    onClick={() => setOpenDateRanger(false)}
                    style={{ textAlign: "center" }}
                  >
                    <BiCheckIcon />
                    Close
                  </button>
                  <button
                    className="closeClearBtn notmalButtonStyles noStyle clearRangerBtn"
                    onClick={!isLoading && clearDateRanger}
                    style={{ textAlign: "center" }}
                    disabled={isLoading}
                  >
                    <BiXIcon />
                    Clear
                  </button>
                </div>
              ) : filters?.selSubscriptionAddDateFrom ||
                filters?.selSubscriptionAddDateTo ? (
                <div className="flex-between">
                  <button
                    type="button"
                    className="notmalButtonStyles noStyle long_one"
                    onClick={() => !isLoading && setOpenDateRanger(true)}
                    style={{ fontSize: "13px" }}
                    disabled={isLoading}
                  >
                    <span className="dates">
                      {moment(filters?.selSubscriptionAddDateFrom)
                        .tz("Asia/Kolkata")
                        .format("DD-MM-YYYY")}
                    </span>
                    <small>TO</small>
                    <span className="dates">
                      {moment(filters?.selSubscriptionAddDateTo)
                        .tz("Asia/Kolkata")
                        .format("DD-MM-YYYY")}
                    </span>
                  </button>

                  <button
                    type="button"
                    className="notmalButtonStyles noStyle short_one"
                    onClick={!isLoading && clearDateRanger}
                    disabled={isLoading}
                  >
                    <span className="icon calender">
                      <RedCrossIcon />
                    </span>
                  </button>
                </div>
              ) : (
                <button
                  type="button"
                  className="notmalButtonStyles noStyle"
                  onClick={() => !isLoading && setOpenDateRanger(true)}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "1rem",
                  }}
                  disabled={isLoading}
                >
                  Select Date Added
                  <span className="icon calender">
                    <CalenderIcon />
                  </span>
                </button>
              )}
            </div>

            <div
              className={`commonWrapper dropdownCommonWrapper ${
                filters?.selectedPaymentLocation?.value && "redBorderRedText"
              }`}
            >
              <SelectDropdown
                options={payment_location}
                selectedOption={filters?.selectedPaymentLocation}
                setSelectedOption={(selectedValue) =>
                  setFilters({
                    ...filters,
                    selectedPaymentLocation: selectedValue,
                  })
                }
                name="Payment Location"
                isDisable={isLoading}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PTTrialFilters;
